import React from 'react';
import {sx} from "./sx";
import PlayStopSvgIcon from "@resource/svg/PlayStopSvgIcon";
import TooltipCustom from "@ui/tooltipCustom/TooltipCustom";
import {sliceString} from "@helpers/string";
import MarkerSvgIcon from "@resource/svg/MarkerSvgIcon";
import {IWayPointCreationSingleVoyage} from "@containers/singleVoyage/types/point";
import {Box, Stack, Typography} from '@mui/material';
import IconButtonCustom from "@ui/buttons/iconButtonCustom/IconButtonCustom";
import {LatLng} from 'leaflet';
import {useMapFeaturesContext} from "@ui/leafletCustom/context/mapContext/hooks/useMapFeaturesContext";
import {getLatLngFromPointGeomCoordinates} from "@helpers/geoJson/getLatLngFromPointGeomCoordinates";
import {useTranslation} from 'react-i18next';
import {IPointTemplatesSingleVoyage} from "@containers/singleVoyage/pointTemplates/types";
import {
	PointTemplateInfoSingleVoyage
} from "@containers/singleVoyage/pointTemplates/pointTemplateInfo/PointTemplateInfoSingleVoyage";
import {
	TrackableObjectsInfoSingleVoyage
} from "@containers/singleVoyage/trackableObjects/trackableObjectsInfo/TrackableObjectsInfoSingleVoyage";

interface IProps {
	targetPoint: IWayPointCreationSingleVoyage,
	pointTemplate: IPointTemplatesSingleVoyage | null
}

const PointHeaderSidebarMutateSingleVoyage = ({
												  targetPoint,
												  pointTemplate,
											  }: IProps) => {
	
	const {mapFeatures} = useMapFeaturesContext()
	
	const toPoint = () => {
		if (!mapFeatures || !targetPoint?.geom?.coordinates?.length) {
			return
		}
		
		const {lat, lng} = getLatLngFromPointGeomCoordinates(targetPoint.geom)
		mapFeatures.setView(new LatLng(lat, lng), 19)
	}
	return (
		<Stack
			gap={1}
		>
			<Stack
				direction={'row'}
				gap={1}
				justifyContent={'space-between'}
				alignItems={'center'}
			>
				<Stack
					gap={'5px'}
					direction={'row'}
				>
					<Box
						sx={sx.nameInner}
					>
						<PlayStopSvgIcon
							sx={sx.icon}
						/>
						
						<TooltipCustom
							title={targetPoint?.name}
						>
							<Typography sx={sx.name}> {sliceString(targetPoint.name, 22)}</Typography>
						</TooltipCustom>
					</Box>
				</Stack>
				<Stack
					direction={'row'}
					gap={'8px'}
					sx={sx.wrapper}
				>
					{mapFeatures && <IconButtonCustom
                        variant={'empty'}
                        onClick={toPoint}
                    >
                        <MarkerSvgIcon/>
                    </IconButtonCustom>}
				</Stack>
			
			</Stack>
			
			{pointTemplate && <PointTemplateInfoSingleVoyage
                pointTemplate={pointTemplate}
            />}
			
			{pointTemplate?.trackableObjects && <TrackableObjectsInfoSingleVoyage
                trackableObjects={pointTemplate.trackableObjects}
            />}
		</Stack>
	);
};

export default PointHeaderSidebarMutateSingleVoyage;
